import type { ReadingBlock, ReadingManifest } from "./readingTracker";

export function readingDisplayCredit(credited: number, required: number): number {
  const value = Math.max(0, Math.min(required, credited));
  return value > 0 && required - value <= Math.min(Math.floor(required / 20), 150) ? required : value;
}

export function readingPercentage(blocks: readonly ReadingBlock[], includeManual = true): number | null {
  let total = 0, credited = 0, started = true;
  for (const block of blocks) for (const segment of block.segments) {
    total += segment.requiredMilliseconds;
    const value = includeManual && block.manuallyRead ? segment.requiredMilliseconds
      : readingDisplayCredit(segment.creditedMilliseconds, segment.requiredMilliseconds);
    credited += value; started &&= value > 0;
  }
  if (!total) return null;
  const percent = 100 * credited / total;
  return started && percent >= 99 ? 100 : percent;
}

export function readingDisplay(manifest: ReadingManifest, credit: (block: ReadingBlock, index: number) => number): ReadingManifest {
  let blocks = manifest.blocks.map(block => ({ ...block, segments: block.segments.map(segment => ({ ...segment,
    creditedMilliseconds: readingDisplayCredit(credit(block, segment.index), segment.requiredMilliseconds) })) }));
  const estimated = readingPercentage(blocks, false), percent = readingPercentage(blocks);
  const required = blocks.flatMap(block => block.segments).reduce((total, segment) => total + segment.requiredMilliseconds, 0);
  const marked = blocks.filter(block => block.manuallyRead).flatMap(block => block.segments).reduce((total, segment) => total + segment.requiredMilliseconds, 0);
  const manualPercent = required ? 100 * marked / required : null;
  // Match the server's completion projection without converting manual marks into timed credit.
  if (estimated === 100) blocks = blocks.map(block => ({ ...block, segments: block.segments.map(segment => ({ ...segment,
    creditedMilliseconds: segment.requiredMilliseconds })) }));
  return { ...manifest, blocks, progress: { ...manifest.progress, percentRead: percent, estimatedPercentRead: estimated, manuallyCoveredPercent: manualPercent,
    ...(manifest.revisionId === manifest.latestRevisionId ? { currentPercentRead: percent, currentEstimatedPercentRead: estimated, currentManuallyCoveredPercent: manualPercent } : {}) } };
}
